<template>
    <div
      v-if="value"
      :class="['master-value-units', customClass]"
    >
      <span v-if="unitPositionStart">{{ unit }}</span>
      <span class="px-1">{{ value }}</span>
      <span v-if="unitPositionEnd">{{ unit }}</span>
    </div>
</template>

<script>

export default {
  name: 'CellRendererMasterValue',
  data() {
    return {
      key: 'Subtitle' // Will need to extract as a prop
    }
  },
  computed: {
    customClass() {
      return this.params.class || '';
    },
    unit() {
      return this.params.unit || '';
    },
    unitPositionStart() {
      return this.params.unitPosition === 'start';
    },
    unitPositionEnd() {
      return this.params.unitPosition === 'end';
    },
    returnFloat() {
      return this.params.returnFloat;
    },
    value () {
      let { value } = this.params;
      if (value === 0) {
        return '0';
      }

      value = this.formatNumber(value);

      if (!this.params.data) {
        const childRows = this.params.node.allLeafChildren;
        const masterRowData = childRows.filter(({ data }) => !data[this.key])
        const masterRow = masterRowData[0].data;

        value = masterRow[this.params.colDef.field];

        return this.formatNumber(value);
      }

      if (!this.params.data[this.key] ) {
        this.params.colDef.hide = true;
        // return '';
      }

      if (!Number.isInteger(value) && !value) {
        return '';
      }

      return value;
    },
  },

  methods: {
    formatNumber(value) {
      if (value === 0) {
        return '0';
      }

      if (this.returnFloat
        && value
        && (Number.isInteger(value) || !Number.isNaN(value))
      ) {
        value = value.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
      }

      return value;
    },
  },
}
</script>
